import { render, staticRenderFns } from "./Lote.vue?vue&type=template&id=2131ed58&"
import script from "./Lote.vue?vue&type=script&lang=js&"
export * from "./Lote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports